module.exports = __webpack_public_path__ + "img/zzf_board_back.400a0b94.jpg";